import React from "react";
import { Modal } from "@/components/ui/feedback/Modal";
import type { OfficeRoom, RoomInfoEntry } from "@/features/office/types";
import styles from "./MeetingRoomModal.module.css";

export interface MeetingRoomModalProps {
  isOpen: boolean;
  room: OfficeRoom | null;
  onClose: () => void;
}

export const MeetingRoomModal: React.FC<MeetingRoomModalProps> = ({
  isOpen,
  room,
  onClose,
}) => {
  const infoEntries: RoomInfoEntry[] = React.useMemo(() => {
    if (!room) {
      return [];
    }

    const entries = [room.info.capacity, room.info.functionality];
    if (room.info.oldName) {
      entries.push(room.info.oldName);
    }
    return entries;
  }, [room]);

  return (
    <Modal
      isOpen={isOpen && !!room}
      onClose={onClose}
      title={room?.name ?? "Rom"}
      data-testid="meeting-room-modal"
      size="md"
    >
      <div className={styles.content}>
        <h3>Rom-informasjon</h3>
        <table className={styles.table}>
          <tbody>
            {infoEntries.map((entry) => (
              <tr key={`${room?.id}-${entry.friendlyName}`}>
                <td>{entry.friendlyName}</td>
                <td>{entry.value}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </Modal>
  );
};

MeetingRoomModal.displayName = "MeetingRoomModal";

export default MeetingRoomModal;
